import { render, staticRenderFns } from "./inventoryBook.vue?vue&type=template&id=4df6ed20&scoped=true&"
import script from "./inventoryBook.vue?vue&type=script&lang=js&"
export * from "./inventoryBook.vue?vue&type=script&lang=js&"
import style0 from "./inventoryBook.vue?vue&type=style&index=0&id=4df6ed20&scoped=true&lang=scss&"
import style1 from "./inventoryBook.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df6ed20",
  null
  
)

export default component.exports